var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.21094H6.875V0.710938H8.125V3.21094ZM8.125 13.2109H6.875V15.7109H8.125V13.2109ZM2.5 7.58594H0V8.83594H2.5V7.58594ZM15 7.58594H12.5V8.83594H15V7.58594ZM14.2969 11.4391L12.1356 10.1828L11.5069 11.2634L13.6681 12.5197L14.2969 11.4391ZM11.8069 2.03969L10.7263 1.41469L9.47 3.57656L10.5506 4.20156L11.8069 2.03969ZM14.3019 4.97719L13.6719 3.89469L11.5125 5.15281L12.1425 6.23344L14.3019 4.97719ZM11.8237 14.3759L10.5625 12.2159L9.4825 12.8459L10.7406 15.0059L11.8237 14.3759ZM3.5 11.2634L2.875 10.1828L0.713125 11.4391L1.33812 12.5197L3.5 11.2634ZM5.5375 3.57594L4.28375 1.41219L3.20375 2.03719L4.46 4.19906L5.5375 3.57594ZM3.5 5.15281L1.33812 3.89469L0.708125 4.97469L2.86813 6.23344L3.5 5.15281ZM5.52562 12.8459L4.445 12.2159L3.1875 14.3759L4.2675 15.0059L5.52562 12.8459Z",
    fill: "#0076DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.f5bd49a0bb03f7995d3991d435e66553.svg";
export { ForwardRef as ReactComponent };